import {
  Interval,
  DateTime,
} from 'luxon';
import * as R from 'ramda';

import {
  actionTypes,
} from '../actions';
import {
  keyValueReducer,
} from './keyValueReducer';


const initialState = {
  initializeInProcess: false,
  profileFetching: false,
  contextView: 'calendar',
  groupBy: 'issues',
  orderBy: 'Created',
  orderByType: 'ascending',
  isGroupByOpen: false,
  isSidebarVisible: true,
  sidebarSearch: '',
  timelineListWidth: 370,
  isFilterOpen: false,

  showGuide: false,

  confirmDeleteWorklogIsOpen: false,
  deleteWorklogId: null,

  worklogFormModalIsOpen: false,
  editWorklogId: null,
  worklogFormDate: null,
  worklogFormIssueId: null,

  screenshotsViewerModalIsOpen: false,
  screenshotsViewerWorklogIds: [],

  shiftKeyDown: false,

  calendarDate: Interval.fromDateTimes(
    DateTime.local().startOf('month'),
    DateTime.local().endOf('month'),
  ),
  datePickerMode: 'Month',

  calendarSelection: [],
  sidebarSelection: {
    issues: [],
    users: [],
    projects: [],
    versions: [],
  },

  flags: [],
  isInfoModalVisible: false,
  isServerSettingsModalVisible: false,
  jiraUrl: null,
  jiraType: 'cloud',
};

const ui = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case actionTypes.SET_UI_STATE: {
      return keyValueReducer(state, action);
    }
    case actionTypes.SELECT_SIDEBAR_ITEMS:
      return {
        ...state,
        sidebarSelection: {
          ...state.sidebarSelection,
          [state.groupBy]: R.without(
            R.intersection(
              action.payload,
              state.sidebarSelection[state.groupBy],
            ),
            R.union(
              action.payload,
              state.sidebarSelection[state.groupBy],
            ),
          ),
        },
      };
    case actionTypes.CLEAR_CALENDAR_SELECTION:
      return {
        ...state,
        calendarSelection: [],
      };
    case actionTypes.CLEAR_ALL_SIDEBAR_ITEMS:
      return {
        ...state,
        sidebarSelection: initialState.sidebarSelection,
      };
    case actionTypes.CLEAR_SIDEBAR_ITEMS:
      return {
        ...state,
        sidebarSelection: {
          ...state.sidebarSelection,
          [action.payload]: [],
        },
      };
    case actionTypes.ADD_FLAG:
      return {
        ...state,
        flags: [action.payload, ...state.flags],
      };
    case actionTypes.DELETE_FLAG: {
      const { id } = action;
      return {
        ...state,
        flags: state.flags.filter(f => f.id !== id),
      };
    }
    default:
      return state;
  }
};

export default ui;
